import type { IRequestHandler } from "./i-handlers";

export class ContentTypeHandler implements IRequestHandler {
    public async handle(request: Request): Promise<void> {
        if (!request.headers.get("Content-Type")) {
            request.headers.append("Content-Type", "application/json");
        }
    }
}
